import { handleError, handleResponse } from '@/services/api/utils/response.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios'

const url = 'termClause'

const api = new ApiCore({
	index: true,
	url: url,
})


api.getTermClause = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

api.getAllTermClause = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}?orgId=${params.orgId}&page=${params.page ?? 1}&count=${params.pageSize ?? 10}&sortBy=${params.key ?? 'modified'}&direction=${params.direction ?? 'desc'}`)
		.then(handleResponse)
		.catch(handleError);
}

api.deleteTermClause = (id) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/${id}`)
		.then(handleResponse)
		.catch(handleError);
}


api.updateTermClauseName = (id, params) => {
    return axios
        .put(`${apiProvider.BASE_URL}/${url}/rename/${id}`, params)
        .then(handleResponse)
        .catch(handleError);
}

api.createTermClause = (params) => {
    return axios
        .post(`${apiProvider.BASE_URL}/${url}`, params)
        .then(handleResponse)
        .catch(handleError);
}

api.updateTermClause = (id, params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${id}`, params)
		.then(handleResponse)
		.catch(handleError);
}

export default api
